"use strict";

require("../../style/css");

require("../../popup/style/css");

require("../../alert/style/css");

require("../../confirm/style/css");

require("../../icon/style/css");

require("./index.css");